import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MenuItem } from 'primeng/api';

export enum ActionButtonType {
  Default = 'default',
  Ghost = 'ghost'
}

@Component({
  standalone: false,
  selector: 'action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.less'],
  encapsulation: ViewEncapsulation.None,
})
export class ActionButtonComponent {
  @Input() id: string = '';
  @Input() label: string = '';
  @Input() icon: string = 'pi pi-caret-down';
  @Input() items: MenuItem[] = [];
  @Input() menuStyle: any;
  @Input() styleClass: string = '';
  @Input() disabled: boolean = false;

  @Input() buttonType: ActionButtonType = ActionButtonType.Default;

  @Input('data-cy') dataCy: string = '';
}
